export const BLACK = "#1A1A1A"
export const TODAY_ORANGE = "#F96815"
export const TODAY_BLUE = "#0075FF"
export const TODAY_INDIGO = "#081236"
export const TODAY_GREEN = "#3CC87A"
export const GRAY_0 = "#F3F3F4"
export const GRAY_1 = "#D2D2D2"
export const GRAY_2 = "#C0BEBE"
export const GRAY_3 = "#8A8A8A"
